module.exports = __webpack_public_path__ + "static/media/chinatown_1.098eadb2.jpg";